import setShowFrequencyToggle from './set_show_frequency_toggle';

export const verticalSagas = [
  setShowFrequencyToggle,
];
